import type { CommonsPayload } from '../lib/types';
import { conditionLabel } from '../lib/schedule';
import { formatRatio } from '../lib/signature';

interface Props { commons?: CommonsPayload; loading?: boolean; onRefresh: () => void }

export function CommonsPanel({ commons, loading, onRefresh }: Props) {
  return (
    <section className="commons-card">
      <div className="section-head">
        <div>
          <p className="kicker">Commons, not extraction</p>
          <h2>The public map of elastic seconds</h2>
          <p>Only aggregate cells are shown here. Raw device-keyed rows stay server-side for export and study.</p>
        </div>
        <button className="ghost" onClick={onRefresh} disabled={loading}>{loading ? 'reading…' : 'refresh map'}</button>
      </div>
      {!commons && <p className="hint">No aggregate map loaded yet. Finish a run or refresh.</p>}
      {commons && (
        <>
          <div className="commons-grid">
            {commons.conditions.map((row) => (
              <div className="commons-cell" key={row.condition}>
                <span>{conditionLabel(row.condition)}</span>
                <strong>{formatRatio(row.avgWarp)}</strong>
                <small>{row.n} trials · arousal {row.avgArousal.toFixed(1)} · focus {row.avgFocus.toFixed(1)}</small>
              </div>
            ))}
          </div>
          <div className="archetypes">
            {commons.archetypes.map((row) => (
              <div key={row.archetype} className="archetype-row">
                <span>{row.archetype}</span>
                <meter min="0" max={Math.max(1, commons.totalSessions)} value={row.n} />
                <strong>{row.n}</strong>
              </div>
            ))}
          </div>
          <p className="timestamp">Generated {new Date(commons.generatedAt).toLocaleString()}</p>
        </>
      )}
    </section>
  );
}
